export class CredentialNumberSettings {
  prefix: string;
  start: number;
  minimumDigits: number;

  constructor(data?: CredentialNumberSettings) {
    if (!data) return;
    this.prefix = data.prefix;
    this.start = data.start;
    this.minimumDigits = data.minimumDigits;
  }
}
